module.exports = __webpack_public_path__ + "img/glasses-8-6.c64eed17.svg";